import { render, staticRenderFns } from "./TabOtherContract.vue?vue&type=template&id=a31c5070&scoped=true"
import script from "./TabOtherContract.vue?vue&type=script&lang=ts"
export * from "./TabOtherContract.vue?vue&type=script&lang=ts"
import style0 from "./TabOtherContract.vue?vue&type=style&index=0&id=a31c5070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31c5070",
  null
  
)

export default component.exports